// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



// WEBPACK FOOTER //
// ./~/core-js/modules/es7.map.of.js